import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalService } from 'src/app/services/modal/modal.service';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { MultiprofessionalMeetingService } from 'src/app/services/multiprofessional-meeting/multiprofessional-meeting.service';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { ReunionPluriprofessionnelle } from 'src/app/utils/interfaces/new/ReunionPluriprofessionnelle';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { EventResource, SuperTypeEnum } from 'src/app/utils/interfaces/new/event-resource.interface';
import { AgendaService } from 'src/app/services/agenda/agenda.service';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { ReunionPluriprofessionnellePersonnelSoignant } from 'src/app/utils/interfaces/new/ReunionPluriprofessionnellePersonnelSoignant';
import { ReunionPluriprofessionnellePatient } from 'src/app/utils/interfaces/new/ReunionPluriprofessionnellePatient';
import { CardIcon } from 'src/app/utils/interfaces/old/card-icon-interface';
import { PatientService } from 'src/app/services/patient/patient.service';
import { ModalPatientsToSeeInMeetingComponent } from '../../../../fragments/modal-patients-to-see-in-meeting/modal-patients-to-see-in-meeting.component';
import { ResultatPatient } from 'src/app/utils/interfaces/new/resultat-patient.interface';
import { ModalPatientsByAntecedentsComponent } from '../../../../fragments/modal-patients-by-antecedents/modal-patients-by-antecedents.component';
import { ModalPrintMeetingComponent, PrintReturn } from './modal-print-meeting/modal-print-meeting.component';
import { CreationReunionPluriprofessionnelle } from 'src/app/utils/interfaces/new/CreationReunionPluriprofessionnelle';
import { CreationReunionPluriprofessionnellePersonnelSoignant, TypeEnum } from 'src/app/utils/interfaces/new/CreationReunionPluriprofessionnellePersonnelSoignant';
import { CreationRendezVous } from 'src/app/utils/interfaces/new/CreationRendezVous';
import { RessourceCreationRendezVous } from 'src/app/utils/interfaces/new/RessourceCreationRendezVous';
import { EventConflictComponent } from '../../agenda/event-conflict/event-conflict.component';
import { Subscription } from 'rxjs';
import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';
import { ModalSelectCaregiversComponent } from '../../../../fragments/modal-select-caregivers/modal-select-caregivers.component';
import { EventType } from 'src/app/utils/interfaces/new/event-type.interface';
import { ConsultationService } from 'src/app/services/consultation/consultation.service';
import { SourceTypeEnum } from 'src/app/utils/interfaces/new/ConsultationSource';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { LoginService } from 'src/app/services/login/login.service';
import { AUTEUR_AUTRE } from 'src/app/utils/interfaces/new/consultation.interface';
import { FroalaEditorDirective } from 'angular-froala-wysiwyg';
import { environment } from 'src/environments/environment';
import { CourriersService } from 'src/app/services/consultation/courriers/courriers.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { HeaderFooterService } from 'src/app/services/header-footer/header-footer.service';
import { SafeHtmlUtils } from 'src/app/utils/safe-html.util';

interface CaregiverTableDisplay {
  name: string;
  status: string;
  id: string;
  meta: ReunionPluriprofessionnellePersonnelSoignant;
}

interface PatientTableDisplay {
  name: string;
  birth: string;
  id: string;
  meta: ReunionPluriprofessionnellePatient;
}

interface AddPatientIcon {
  title: string;
  icon: CardIcon;
}

interface SelectPatient {
  doSelect: boolean;
  patientId: string;
}

interface TempMeetingForm {
  meetingInfos: ReunionPluriprofessionnelle;
  meetingId?: string;
  caregivers?: Array<CaregiverTableDisplay>;
  patients?: Array<PatientTableDisplay>;
  initialMeeting?: ReunionPluriprofessionnelle;
}

@Component({
  selector: 'app-edit-meeting',
  templateUrl: './edit-meeting.component.html',
  styleUrls: ['./edit-meeting.component.scss']
})
export class EditMeetingComponent implements OnInit, OnDestroy {

  editorContent: string = '';
    editorOptions: Object = {
      pluginsEnabled: [
        'table', 'fontSize', 'fontFamily', 
        'link', 'image', 'emoticons',
        'specialCharacters', 'embedly', 
         'fullscreen','selectAll','help',
        'paragraphFormat', 'paragraphStyle', 'align', 'lists', 'colors', 'lineHeight', 'quote'
      ],
      fontSize: ['6','8','10', '12', '14', '16', '18', '24', '36'],
      language: 'fr',
      toolbarButtons: [
        [ 'insertTable','insertLink', 'insertImage','embedly','emoticons', 'specialCharacters', ],
        [ 'bold', 'italic', 'underline', 'strikeThrough','textColor', 'backgroundColor','clearFormatting'],
        ['fontFamily', 'fontSize', 'quote', 'paragraphFormat', 'paragraphStyle'],
        ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'lineHeight', 'outdent', 'indent'],
        ['undo', 'redo', 'fullscreen', 'selectAll', 'help']
      ],
      height: 200,
      width: '100%',
      tabSpaces: 8,
      key: environment.froalaKey,
      attribution: false,
      events: {
          'image.beforeUpload': function (images) {
            // Convertir en base64 sinon on ne stocke que l'url locale de l'image
            const editor = this;
      
            if (images.length) {
              const reader = new FileReader();
      
              reader.onload = function (e) {
                editor.image.insert(e.target.result, null, null, editor.image.get());
              };
      
              reader.readAsDataURL(images[0]);
            }
      
            return false;
          }
        }
      };
    
    @ViewChild('froalaDrop') public froalaEditorDirective!:FroalaEditorDirective;
    editorInstance: any = null;
    initControls: any = null;
  

  public dateMask = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  };

  public meetingId: string;
  public initialMeeting: ReunionPluriprofessionnelle;
  public formGroup: FormGroup;
  private _resources: Array<EventResource> = [];
  public profilResources: Array<string> = [];
  public materialResources: Array<string> = [];
  public caregiversTable: Paginated<CaregiverTableDisplay>;
  public caregiversTableColumn = [
    { title: 'Nom', data: 'name' },
    { title: 'Est présent', data: 'status' },
    { title: 'Présent', data: null },
    { title: 'Supprimer', data: null }
  ];
  public patientsTable: Paginated<PatientTableDisplay>;
  public patientsTableColumn = [
    { title: 'Nom', data: 'name' },
    { title: 'Date de naiss.', data: 'birth' },
    { title: 'Supprimer', data: null }
  ];
  public searchPatientButton: AddPatientIcon = {
    title: 'Rechercher un patient',
    icon: {
      src: 'assets/icons/search.svg',
      color: 'var(--primary)',
      fill: 'var(--primary)'
    }
  };
  public patientToSeeButton: AddPatientIcon = {
    title: 'Patients à voir en réunion',
    icon: {
      src: 'assets/icons/eye.svg',
      color: 'var(--primary)',
      fill: 'var(--primary)'
    }
  };
  public listByAntecedentsButton: AddPatientIcon = {
    title: 'Liste par antécédent',
    icon: {
      src: 'assets/icons/document.svg',
      color: 'var(--primary)',
      fill: 'var(--primary)'
    }
  };
  public addToPatientConsultationsButton: AddPatientIcon = {
    title: 'Ajouter aux consultations',
    icon: {
      src: 'assets/icons/consultation.svg',
      color: 'var(--primary)',
      fill: 'var(--primary)'
    }
  };
  public selectedPatients: Array<PatientTableDisplay> = [];
  private _formChangeSub: Subscription;
  public hasFormChange = false;

  public customTimePickerTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: 'var(--white)',
    },
    dial: {
      dialBackgroundColor: 'var(--primary)',
    },
    clockFace: {
      clockFaceBackgroundColor: 'var(--box-shadow-grey)',
      clockHandColor: 'var(--primary)',
      clockFaceTimeInactiveColor: 'var(--white)'
    }
  };
  private _defaultEventType: EventType;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _send: HeaderCommunicationService,
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _mpmSrv: MultiprofessionalMeetingService,
    private _agendaSrv: AgendaService,
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _patientSrv: PatientService,
    private _consultationSrv: ConsultationService,
    private _strUtilsSrv: StringUtilsService,
    private _login: LoginService,
    private _courriersSrv: CourriersService,
    private _snackbar: SnackbarService,
    private _headFootSrv: HeaderFooterService
  ) {
    this.meetingId = this._activatedRoute.snapshot.params.meetingId;
    if (this.meetingId) {
      const head: Header = {
        backPage: 'reunions',
        isBack: true,
        title: 'Éditer réunion pluriprofessionnelles',
        backCallBack: async () => this.cancelBackButton()
      };
      this._send.announceHeader(head);
    } else {
      const head: Header = {
        backPage: 'reunions',
        isBack: true,
        title: 'Créer une réunion pluriprofessionnelles',
        backCallBack: async () => this.cancelBackButton()
      };
      this._send.announceHeader(head);
    }
  }

  async ngOnInit(): Promise<void> {
    await this._initData();
  }

  /**
   * Initialisation de l'éditeur pour accéder aux méthodes de froala pour cibler l'éditeur, pour le drag and drop
   * @param initControls 
   */
  initialize(initControls: any) {
    this.initControls = initControls;
    this.initControls.initialize();

    setTimeout(() => {
      this.editorInstance = this.initControls.getEditor();

    });
  }

  ngOnDestroy(): void {
    if (this._formChangeSub) {
      this._formChangeSub.unsubscribe();
    }
  }

  public removeCaregiver(event: CaregiverTableDisplay): void {
    // Lorsque l'ajout de personnels soignants sera en place
    this.caregiversTable.objects.splice(this.caregiversTable.objects.findIndex(p => p.id === event.id), 1);
  }

  public caregiverIsPresent(event: CaregiverTableDisplay): void {
    // Lorsque l'ajout de personnels soignants sera en place
    event.meta.estPresent = !event.meta.estPresent;
    event.status = event.meta.estPresent ? 'Oui' : 'Non';
  }

  public addCaregiver(): void {
    const modal = this._modalSrv.openModal(this._viewContainerRef, ModalSelectCaregiversComponent);
    if (this.patientsTable && this.patientsTable.objects && this.patientsTable.objects.length > 0) {
      const patientsId: Array<string> = [];
      for (const p of this.patientsTable.objects) {
        patientsId.push(p.id);
      }
      modal.instance.patientsId = patientsId;
    }
    const sub = modal.instance.closeEmitter.subscribe((value?: Array<ReunionPluriprofessionnellePersonnelSoignant>) => {
      if (value) {
        for (const ps of value) {
          if ((this.caregiversTable
            && this.caregiversTable.objects
            && this.caregiversTable.objects.length > 0
            && !this.caregiversTable.objects.find((pp) => {
              return (ps.type !== TypeEnum.IntervenantExterne && pp.id === ps.id)
                || (ps.type === TypeEnum.IntervenantExterne && pp.name === ps.nom);
            }))
            || (!this.caregiversTable
              || !this.caregiversTable.objects
              || this.caregiversTable.objects.length === 0)) {
            this._addCaregiverToDisplayTable({
              id: ps.id,
              nom: ps.nom,
              type: ps.type
            });
          }
        }
      }
      modal.destroy();
      sub.unsubscribe();
    });
  }

  public removePatient(patient: PatientTableDisplay): void {
    const modal = this._modalSrv.openModalConfirmation(this._viewContainerRef, 'Retirer patient', 'Voulez-vous retirer ce patient de la réunion ?');
    const sub = modal.instance.closeEmitter.subscribe((res) => {
      if (res) {
        this.patientsTable.objects.splice(this.patientsTable.objects.findIndex(p => p.id === patient.id), 1);
        this.selectedPatients.splice(this.selectedPatients.findIndex(p => p.id === patient.id), 1);
      }
      sub.unsubscribe();
    });
  }

  public async searchPatient(): Promise<void> {
    localStorage.setItem('meetingSaveTmp', JSON.stringify({
      meetingInfos: this._getMeetingFromForm(),
      caregivers: this.caregiversTable && this.caregiversTable.objects && this.caregiversTable.objects.length > 0
        ? this.caregiversTable.objects : undefined,
      patients: this.patientsTable && this.patientsTable.objects && this.patientsTable.objects.length > 0
        ? this.patientsTable.objects : undefined,
      meetingId: this.meetingId ? this.meetingId : undefined,
      initialMeeting: this.initialMeeting
    } as TempMeetingForm));

    await this._router.navigateByUrl(
      this._router.createUrlTree(
        ['/user/patient'], {
        queryParams: {
          navigateToMultiprofessionnalMeetingEditSearch: true,
          meetingId: this._activatedRoute.snapshot.params.meetingId
        }
      }
      )
    );
  }

  public openPatientsToSee(): void {
    const modal = this._modalSrv.openModal(this._viewContainerRef, ModalPatientsToSeeInMeetingComponent);
    const sub = modal.instance.closeEmitter.subscribe(async (selectedPatients: Array<ResultatPatient>) => {
      if (selectedPatients && selectedPatients.length > 0) {
        for (const p of selectedPatients) {
          if ((this.patientsTable
            && this.patientsTable.objects
            && this.patientsTable.objects.length > 0
            && !this.patientsTable.objects.find(pp => pp.id === p.id))
            || (!this.patientsTable
              || !this.patientsTable.objects
              || this.patientsTable.objects.length === 0)) {
            const patient = await this._patientSrv.findOnePatientInfos(p.id);
            this._addPatientToDisplayTable({
              dateDeNaissance: moment(patient.dateNaissance).toDate(),
              id: patient.id,
              nom: patient.nom.toLocaleUpperCase(),
              prenom: this._strUtilsSrv.uppercaseFirstCharString(patient.prenom)
            });
          }
        }
      }
      modal.destroy();
      sub.unsubscribe();
    });
  }

  public openListByAntecedents(): void {
    const modal = this._modalSrv.openModal(this._viewContainerRef, ModalPatientsByAntecedentsComponent);
    const sub = modal.instance.closeEmitter.subscribe(async (selectedPatients: Array<ResultatPatient>) => {
      if (selectedPatients && selectedPatients.length > 0) {
        for (const p of selectedPatients) {
          if ((this.patientsTable
            && this.patientsTable.objects
            && this.patientsTable.objects.length > 0
            && !this.patientsTable.objects.find(pp => pp.id === p.id))
            || (!this.patientsTable
              || !this.patientsTable.objects
              || this.patientsTable.objects.length === 0)) {
            const patient = await this._patientSrv.findOnePatientInfos(p.id);
            this._addPatientToDisplayTable({
              dateDeNaissance: moment(patient.dateNaissance).toDate(),
              id: patient.id,
              nom: patient.nom.toLocaleUpperCase(),
              prenom: this._strUtilsSrv.uppercaseFirstCharString(patient.prenom)
            });
          }
        }
      }
      modal.destroy();
      sub.unsubscribe();
    });
  }

  public addRemovePatient(event: PatientTableDisplay): void {
    if (!this.selectedPatients.includes(event)) {
      this._doSelectPatient({ doSelect: true, patientId: event.id });
      this.selectedPatients.push(event);
    } else {
      this._doSelectPatient({ doSelect: false, patientId: event.id });
      const index = this.selectedPatients.findIndex(e => e.id === event.id);
      this.selectedPatients.splice(index, 1);
    }
  }

  public async addMeetingToPatientsConsultations(): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      let date: Date;

      if (this.initialMeeting && this.initialMeeting.dateDebut) {
        date = this.initialMeeting.dateDebut;
      } else if (this.formGroup.get('dateStart').value
        && this.formGroup.get('hourStart').value) {
        date = moment(this.formGroup.get('dateStart').value)
          .hour(Number(this.formGroup.get('hourStart').value.split(':')[0]))
          .minute(Number(this.formGroup.get('hourStart').value.split(':')[1]))
          .second(0)
          .millisecond(0)
          .toDate();
      } else {
        date = new Date();
      }

      for (const p of this.selectedPatients) {
        if (!p.meta.consultationId) {
          const currentProfil = this._login.getCurrentProfil();
          const consultationId = await this._consultationSrv.create({
            date,
            idPatient: p.id,
            titre: this.formGroup.get('title').value,
            consultationSource: {
              sourceId: this.initialMeeting.id,
              sourceType: SourceTypeEnum.MultiprofessionalMeeting
            },
            id: p.meta.consultationId,
            auteur: {
              id: currentProfil && currentProfil.id ? currentProfil.id : undefined,
              autre: !currentProfil || !currentProfil.id ? AUTEUR_AUTRE : undefined
            }
          });

          // Créer un courrier avec le compte-rendu de la réunion
          if (consultationId) {
            try {
              let courrierContent = '';
              
              if (date) {
                courrierContent += `<p><strong>Date :</strong> ${moment(date).format('DD/MM/YYYY')}`;
                if (this.formGroup.get('hourStart').value) {
                  courrierContent += ` à ${this.formGroup.get('hourStart').value}`;
                }
                courrierContent += `</p>`;
              }

              if (this.formGroup.get('ordreDuJour').value) {
                courrierContent += `<h2>Ordre du jour</h2>`;
                courrierContent += `<div>${this.formGroup.get('ordreDuJour').value}</div>`;
              }

              if (this.formGroup.get('report').value) {
                courrierContent += `<h2>Compte-rendu</h2>`;
                courrierContent += `<div>${this.formGroup.get('report').value}</div>`;
              }
              await this._courriersSrv.create({
                idConsultation: consultationId,
                courrierText: courrierContent,
                titre: this.formGroup.get('title').value || 'Réunion pluriprofessionnelle',
                isEnteteVide: false,
                isPiedVide: false,
                isDuplicata: false,
                isImpressionPatient: false,
                isVilleDate: true,
                isNomPatient: false,
                versionCourrier: 1
              }, consultationId);
            } catch (courrierError) {
              console.error('Erreur lors de la création du courrier:', courrierError);
            }
          }
        }
      }
      
      this._modalSrv.openAlert(this._viewContainerRef, 'Compte-rendu ajouté', 'Le compte-rendu de la réunion a bien été ajouté aux consultations des patients sélectionnés');
    } finally {
      this._modalSrv.close(loading);
    }
  }

  public printMeeting(): void {
    const modal = this._modalSrv.openModal(this._viewContainerRef, ModalPrintMeetingComponent);
    modal.instance.printCoordinatorHeader = this.formGroup.get('printCoordinatorHeader').value;
    modal.instance.printInformations = this.formGroup.get('printInformations').value;
    const sub = modal.instance.closeEmitter.subscribe(async (printOptions: PrintReturn) => {
      this.formGroup.get('printCoordinatorHeader').patchValue(printOptions.printOptions.printCoordinatorHeader);
      this.formGroup.get('printInformations').patchValue(printOptions.printOptions.printInformations);
      if (printOptions.doPrint) {
        let coordinatorId = null;
        if (this.formGroup.get('printCoordinatorHeader').value) {
          const coordinatorName = this.formGroup.get('coordinator').value;
          const coordinatorResource = this._resources.find(r => r.nom === coordinatorName);
          if (coordinatorResource) {
            coordinatorId = coordinatorResource.id;
          }
        }

        let meetingInfosHtml = '';
        if (this.formGroup.get('printInformations').value) {
          const title = SafeHtmlUtils.escapeHtml(this.formGroup.get('title').value || '');
          const dateStart = this.formGroup.get('dateStart').value ? moment(this.formGroup.get('dateStart').value).format('DD/MM/YYYY') : '';
          const hourStart = this.formGroup.get('hourStart').value || '';
          const hourEnd = this.formGroup.get('hourEnd').value || '';
          const room = this.formGroup.get('room').value || '';
          const address = SafeHtmlUtils.escapeHtml(this.formGroup.get('address').value || '');
          const ordreDuJour = SafeHtmlUtils.escapeHtml(this.formGroup.get('ordreDuJour').value || '');


      let caregiversHtml = '';
      if (this.caregiversTable && this.caregiversTable.objects && this.caregiversTable.objects.length > 0) {
        caregiversHtml = `
          <div>
            <h3>Personnel soignant : </h3>
            <p>
        `;
        for (const c of this.caregiversTable.objects) {
          caregiversHtml += SafeHtmlUtils.escapeHtml(`${c.name} , `);
        }
        caregiversHtml += `</p></div>`;
      }

      let patientsHtml = '';
      if (this.patientsTable && this.patientsTable.objects && this.patientsTable.objects.length > 0) {
        patientsHtml = `
          <div>
            <h3>Patients concernés</h3>
            <p>
        `;
        for (const p of this.patientsTable.objects) {
          patientsHtml += SafeHtmlUtils.escapeHtml(`${p.name} ${p.birth ? ' (' + p.birth + ')' : ''}, `);
        }
        patientsHtml += `</p></div>`;
      }


      meetingInfosHtml = `
            <div style="margin-bottom: 20px; font-family: Arial, sans-serif;">
              <h2 style="text-align: center; color: #333;">${title}</h2>
              <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
                <tr>
                  <td style="padding: 5px; font-weight: bold;">Date :</td>
                  <td style="padding: 5px;">${dateStart ? dateStart : ''} ${hourStart ? 'de ' + hourStart : ''} ${hourEnd ? 'à ' + hourEnd : ''}</td>
                </tr>
                ${room ? `<tr><td style="padding: 5px; font-weight: bold;">Salle :</td><td style="padding: 5px;">${room}</td></tr>` : ''}
                ${address ? `<tr><td style="padding: 5px; font-weight: bold;">Adresse :</td><td style="padding: 5px;">${address}</td></tr>` : ''}
                ${ordreDuJour ? `<tr><td style="padding: 5px; font-weight: bold; vertical-align: top;">Ordre du jour :</td><td style="padding: 5px;">${ordreDuJour}</td></tr>` : ''}
              </table>
              ${caregiversHtml}
              ${patientsHtml}
              <hr style="border: 0; border-top: 1px solid #ccc; margin: 20px 0;">
            </div>
          `;
    }

        const reportContent = SafeHtmlUtils.sanitizeHtmlString(this.formGroup.get('report').value || '');
        const fullContent = meetingInfosHtml + reportContent;


        try {
          await this._printMeetingDirect(fullContent, coordinatorId);
        } catch (e) {
          console.error('Erreur lors de l\'impression', e);
          this._snackbar.openSnackBarError('Impossible d\'imprimer le document.');
        }
      }
      modal.destroy();
      sub.unsubscribe();
    });
  }

  /**
   * Impression directe du compte rendu de réunion sans passer par le service display-document
   */
  private async _printMeetingDirect(content: string, coordinatorId: string | null): Promise<void> {
    let header = '';
    let headerHeight = 0;
    const printHeader = this.formGroup.get('printCoordinatorHeader').value;
    
    if (printHeader && coordinatorId) {
      const rawHeader = await this._headFootSrv.findOneHeader(coordinatorId);
      if (rawHeader?.texte) {
        header = SafeHtmlUtils.sanitizeHtmlString(rawHeader.texte);
        headerHeight = rawHeader.headerHeight || 0;
      }
    }

    let footer = '';
    let footerHeight = 0;
    if (coordinatorId) {
      const rawFooter = await this._headFootSrv.findOneFooter(coordinatorId);
      if (rawFooter?.texte) {
        footer = SafeHtmlUtils.sanitizeHtmlString(rawFooter.texte);
        footerHeight = rawFooter.footerHeight || 0;
      }
    }

    const title = SafeHtmlUtils.escapeHtml(this.formGroup.get('title').value || 'Réunion Pluriprofessionnelle');
    const customPrintStyle = `
      body {
       font-family: Arial, sans-serif;
      }
      
      table, th, td {
        border: 1px solid grey;
        border-collapse: collapse;
      }
      
      .entete {
        width: 100%;
        position: running(entete);
      }
      
      .entete img {
        max-width: 100%;
      }
      
      .ql-editor {
        padding: 0 !important;
      }
      
      .pied {
        width: 100%;
        position: running(pied);
      }
      
      .content h6,
      .content h5,
      .content h4 {
        margin: 0 !important;
        font-weight: normal !important;
      }
      
      .content p {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
      }
      
      .content .ql-align-center {
        text-align: center !important;
      }
      
      .content .ql-align-right {
        text-align: right !important;
      }
      
      .content .ql-align-left {
        text-align: left !important;
      }
      
      .content p, li, h5 {
        font-size: 13px !important;
      }
      
      .content h4, ul {
        font-size: 16px !important;
      }
      
      .content h6 {
        font-size: 11px !important;
      }
      
      .content h3 {
        font-size: 18px !important;
      }
      
      .content h2 {
        font-size: 20px !important;
      }
      
      .content h1 {
        font-size: 24px !important;
      }
      
      .content {
        margin-top: 20px;
        height: auto;
        display: block;
      }
      
      @page {
        size: A4;
        margin-left: 10mm;
        margin-right: 10mm;
        margin-top: ${printHeader ? `${headerHeight + 10}px` : '2cm'} !important;
        margin-bottom: ${footerHeight}px !important;
        
        @top-center {
          padding-top: 20px 0px;
          content: element(entete);
        }
        
        @bottom-center {
          content: element(pied);
        }
      }
    `;

    const fullHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="UTF-8">
          <title>${title}</title>
          <style>
            ${customPrintStyle}
          </style>
          <link href="https://cdnjs.cloudflare.com/ajax/libs/froala-editor/2.8.4/css/froala_editor.pkgd.min.css" rel="stylesheet" type="text/css">
          <link href="https://cdnjs.cloudflare.com/ajax/libs/froala-editor/2.8.4/css/froala_style.min.css" rel="stylesheet" type="text/css">
          <link href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.bubble.css" rel="stylesheet">
          <link href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.core.css" rel="stylesheet">
          <link href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.snow.css" rel="stylesheet">
          <script src="https://unpkg.com/pagedjs/dist/paged.polyfill.js"></script>
        </head>
        <body class="fr-view">
          ${printHeader ? `<div class="entete ql-editor">${header}</div>` : '<div class="entete"></div>'}
          <div class="pied ql-editor">${footer}</div>
          <div class="content">
            ${content}
          </div>
        </body>
      </html>
    `;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow?.document;
    if (iframeDoc) {
      iframeDoc.open();
      iframeDoc.write(fullHtml);
      iframeDoc.close();
      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow?.print();
          // Nettoyer l'iframe après un délai
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 1000);
        }, 1500); // Délai plus long pour PagedJS
      };
    }
  }

  //L'envoi par mail n'étant pas une demande segur v2 il faudra gérer l'implémentation plus tard
  // public sendMeetingByMail(): void {
  //   // TODO Envoi de mail
  // }

  public async validMeeting(): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    const updateAgendaEvent = (): Promise<boolean> => {
      return new Promise<boolean>((resolve) => {
        if (this.initialMeeting && this.initialMeeting.dateDebut && this.initialMeeting.dateFin && this.initialMeeting.rendezVousId) {
          const meeting = this._getCreationMeetingFromForm();
          if (meeting.dateDebut && meeting.dateFin
            && (!moment(this.initialMeeting.dateDebut).isSame(moment(meeting.dateDebut))
              || !moment(this.initialMeeting.dateFin).isSame(moment(meeting.dateFin))
              || ((!this.initialMeeting.salle && meeting.salleRessourceId) || (this.initialMeeting.salle && this.initialMeeting.salle.id !== meeting.salleRessourceId))
              || (this.initialMeeting.coordinateur.id !== meeting.coordinateurResourceId)
              || (this.initialMeeting.secretaire.id !== meeting.secretaireResourceId))) {
            const confirm = this._modalSrv.openModalConfirmation(this._viewContainerRef, 'Réunion modifiée', 'Vous avez modifié cette réunion, souhaitez-vous le mettre à jour dans l’agenda des personnes participantes ?');
            const sub = confirm.instance.closeEmitter.subscribe((value) => {
              resolve(value);
              sub.unsubscribe();
            });
          } else {
            resolve(false);
          }
        } else {
          resolve(true);
        }
      });
    };

    try {
      // On vérifie la validité de tout les champs obligatoire pour la validation
      if (!this.canValidMeeting()) {
        this._modalSrv.close(loading);
        return;
      }

      const doUpdateAgendaEvent = await updateAgendaEvent();

      if (doUpdateAgendaEvent) {
        // On vérifie la possiblité de prendre en rendez-vous (conflits)
        const canCreateAgendaEvent = await this._checkCreateAgendaEvent();
        if (!canCreateAgendaEvent) {
          this._modalSrv.close(loading);
          return;
        }

        // On enregistre le rendez-vous dans les agendas des ressources
        const eventToCreate = await this._generateAgendaEvent();
        if (this.initialMeeting && this.initialMeeting.rendezVousId && this.initialMeeting.rendezVousId !== '') {
          const ressourses: Array<EventResource> = [];
          if (eventToCreate.ressoursesId && eventToCreate.ressoursesId.length > 0) {
            for (const r of eventToCreate.ressoursesId) {
              ressourses.push({ id: r.id, superType: r.type as SuperTypeEnum, nom: null, responsableId: null, type: null });
            }
          }
          await this._agendaSrv.updateEvent({
            createdAt: null,
            createdBy: null,
            id: this.initialMeeting.rendezVousId,
            dateDebut: eventToCreate.dateDebut,
            dateFin: eventToCreate.dateFin,
            description: eventToCreate.description,
            ressourses,
            planifie: true,
            type: this._defaultEventType
          }, true);
        } else {
          const event = await this._agendaSrv.createEvent(eventToCreate, true);
          if (event) {
            this.formGroup.get('eventId').patchValue(event.id);
          }
        }
      }

      // On enregistre la réunion
      await this._saveMeeting();
      this._goToReunionsTable();
    } catch (e) {
      this._showAlert('Une erreur est survenue lors de la validation de cette réunion.');
    } finally {
      this._modalSrv.close(loading);
    }
  }

  public canValidMeeting(): boolean {
    const meeting = this._getCreationMeetingFromForm();

    if (!meeting.dateDebut || !meeting.dateFin || !meeting.titre || !meeting.ordreDuJour
      || !meeting.coordinateurResourceId || !meeting.secretaireResourceId) {
      return false;
    }

    if (moment(meeting.dateDebut).isSameOrAfter(meeting.dateFin)) {
      return false;
    }

    if (!this.caregiversTable || !this.caregiversTable.objects || this.caregiversTable.objects.length === 0) {
      return false;
    }

    return true;
  }

  public async saveMeeting(): Promise<void> {
    if (!this.canValidMeeting()) {
      this._showAlert('Veuillez remplir tous les champs obligatoires avant d\'enregistrer.');
      return;
    }

    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      await this._saveMeeting();
      this._snackbar.openSnackBarSuccess('La réunion a été enregistrée avec succès');
    } catch (e) {
      this._showAlert('Une erreur est survenue lors de l\'enregistrement de cette réunion.');
      throw e;
    } finally {
      this._modalSrv.close(loading);
    }
  }

  public cancelChanges(): void {
    if (this.hasFormChange) {
      const modal = this._modalSrv.openModalConfirmation(this._viewContainerRef, 'Réunion modifiée', 'Si vous quittez, les modifications effectuées sur cette réunion seront effacées. Voulez-vous vraiment quitter ?');
      const sub = modal.instance.closeEmitter.subscribe((res) => {
        if (res) {
          this._goToReunionsTable();
        }
        sub.unsubscribe();
      });
    }
  }

  public deleteMeeting(): void {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);
    try {
      const modal = this._modalSrv.openModalConfirmation(this._viewContainerRef, 'Confirmation', 'Voulez-vous supprimer cette réunion ?');
      const sub = modal.instance.closeEmitter.subscribe(async (doDelete: boolean) => {
        if (doDelete) {
          if (this.meetingId) {
            await this._mpmSrv.deleteMultiprofessionnalMeetings(this.meetingId);
          }
          this._goToReunionsTable();
        }
        sub.unsubscribe();
      });
    } catch (e) {
      throw e;
    } finally {
      this._modalSrv.close(loading);
    }
  }

  public timeChanged(event: string, control: string): void {
    this.formGroup.get(control).patchValue(event);
  }

  private _goToReunionsTable(): void {
    this._router.navigateByUrl('/user/reunions');
  }

  private async _initData(): Promise<void> {
    const modal = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      this._resources = await this._getResources();

      for (const r of this._resources) {
        if (r.superType === SuperTypeEnum.Profil) {
          this.profilResources.push(r.nom);
        } else if (r.superType === SuperTypeEnum.Ressource) {
          this.materialResources.push(r.nom);
        }
      }

      if (this.meetingId) {
        this.initialMeeting = await this._getMeeting(this.meetingId);
        this._initForm(this.initialMeeting);
      } else {
        this._initForm();
      }

      const doAddPatient = this._activatedRoute.snapshot.queryParamMap.get('doAddPatient');
      const patientToAddId = this._activatedRoute.snapshot.queryParamMap.get('patientId');
      if (doAddPatient && doAddPatient === 'true' && patientToAddId && patientToAddId !== '') {
        if ((this.patientsTable
          && this.patientsTable.objects
          && this.patientsTable.objects.length > 0
          && !this.patientsTable.objects.find(pp => pp.id === patientToAddId))
          || (!this.patientsTable
            || !this.patientsTable.objects
            || this.patientsTable.objects.length === 0)) {
          // On récupère le patient lié à l'ID
          const patient = await this._patientSrv.findOnePatientInfos(patientToAddId);
          if (patient) {
            // On ajoute le patient au tableau des patients
            this._addPatientToDisplayTable({
              dateDeNaissance: moment(patient.dateNaissance).toDate(),
              id: patient.id,
              nom: patient.nom.toLocaleUpperCase(),
              prenom: this._strUtilsSrv.uppercaseFirstCharString(patient.prenom)
            });
          }
        }
      }
    } catch (e) {
      this._showAlert();
    } finally {
      this._modalSrv.close(modal);
    }
  }

  private _initForm(meeting?: ReunionPluriprofessionnelle): void {
    if (meeting && meeting.personnelSoignant && meeting.personnelSoignant.length > 0) {
      for (const p of meeting.personnelSoignant) {
        this._addCaregiverToDisplayTable(p);
      }
    }

    if (meeting && meeting.patients && meeting.patients.length > 0) {
      for (const p of meeting.patients) {
        this._addPatientToDisplayTable(p);
      }
    }

    const currentProfilStr = localStorage.getItem('currentProfil');
    const currentProfil = JSON.parse(currentProfilStr);
    const coordinator = meeting && meeting.coordinateur
      ? meeting.coordinateur.nom
      : this._resources.find(r => r.id === currentProfil.id).nom;

    const secretary = meeting && meeting.secretaire
      ? meeting.secretaire.nom
      : this._resources.find(r => r.id === currentProfil.id).nom;

    if (localStorage.getItem('meetingSaveTmp')) {
      const meetingTmp = JSON.parse(localStorage.getItem('meetingSaveTmp')) as TempMeetingForm;
      if (meetingTmp) {
        meeting = meetingTmp.meetingInfos;
        this.caregiversTable = meetingTmp.caregivers && meetingTmp.caregivers.length > 0 ? {
          objects: meetingTmp.caregivers,
          page: 0, perpage: 0, total: 0
        } : undefined;
        this.patientsTable = meetingTmp.patients && meetingTmp.patients.length > 0 ? {
          objects: meetingTmp.patients,
          page: 0, perpage: 0, total: 0
        } : undefined;
        this.meetingId = meetingTmp.meetingId;
        this.initialMeeting = meetingTmp.initialMeeting;
      }
      localStorage.removeItem('meetingSaveTmp')
    }

    this.formGroup = this._formBuilder.group({
      title: [meeting && meeting.titre ? meeting.titre : undefined, Validators.required],
      dateStart: [meeting && meeting.dateDebut ? moment(meeting.dateDebut).format('YYYY-MM-DD') : undefined, Validators.required],
      hourStart: [meeting && meeting.dateDebut && meeting.dateFin ? moment(meeting.dateDebut).format('HH:mm') : '', Validators.required],
      hourEnd: [meeting && meeting.dateDebut && meeting.dateFin ? moment(meeting.dateFin).format('HH:mm') : '', Validators.required],
      room: [meeting && meeting.salle ? meeting.salle.nom : undefined],
      address: [meeting && meeting.adresse ? meeting.adresse : undefined],
      ordreDuJour: [meeting && meeting.ordreDuJour ? meeting.ordreDuJour : undefined, Validators.required],
      report: [meeting && meeting.compteRendu ? meeting.compteRendu : undefined],
      isConsultationMeeting: [meeting && meeting.estReunionDInformation ? true : false],
      isCoordinationMeeting: [meeting && meeting.estReunionDeConcertation ? true : false],
      updatedAt: [meeting && meeting.dateModification
        ? `Dernière modification le ${moment(meeting.dateModification).format('DD/MM/YYYY')} à ${moment(meeting.dateModification).format('HH')}h${moment(meeting.dateModification).format('mm')}`
        : undefined],
      secretary: [secretary, Validators.required],
      coordinator: [coordinator, Validators.required],
      printCoordinatorHeader: [meeting && meeting.impressionEnTeteCoordinateur ? true : false],
      printInformations: [meeting && meeting.impressionInformation ? true : false],
      eventId: [meeting && meeting.rendezVousId ? meeting.rendezVousId : undefined]
    });

    this._formChangeSub = this.formGroup.valueChanges.subscribe(() => {
      this.hasFormChange = true;
    });
  }

  private _addPatientToDisplayTable(patient: ReunionPluriprofessionnellePatient): void {
    if (this.patientsTable) {
      this.patientsTable.objects.push({
        id: patient.id,
        meta: patient,
        name: `${patient.nom.toLocaleUpperCase()} ${this._strUtilsSrv.uppercaseFirstCharString(patient.prenom)}`,
        birth: moment(patient.dateDeNaissance).format('DD/MM/YYYY')
      });
    } else {
      this.patientsTable = {
        objects: [{
          id: patient.id,
          meta: patient,
          name: `${patient.nom.toLocaleUpperCase()} ${this._strUtilsSrv.uppercaseFirstCharString(patient.prenom)}`,
          birth: moment(patient.dateDeNaissance).format('DD/MM/YYYY')
        }],
        page: 0,
        perpage: 0,
        total: 0
      };
    }
  }

  private _addCaregiverToDisplayTable(caregiver: ReunionPluriprofessionnellePersonnelSoignant): void {
    if (this.caregiversTable) {
      this.caregiversTable.objects.push({
        id: caregiver.id,
        meta: caregiver,
        name: caregiver.nom,
        status: caregiver.estPresent ? 'Oui' : 'Non'
      });
    } else {
      this.caregiversTable = {
        objects: [{
          id: caregiver.id,
          meta: caregiver,
          name: caregiver.nom,
          status: caregiver.estPresent ? 'Oui' : 'Non'
        }],
        page: 0,
        perpage: 0,
        total: 0
      };
    }
  }

  private async _getMeeting(meetingId: string): Promise<ReunionPluriprofessionnelle> {
    return new Promise<ReunionPluriprofessionnelle>(async (resolve, reject) => {
      try {
        const meeting = await this._mpmSrv.getOneMultiprofessionnalMeeting(meetingId);
        resolve(meeting);
      } catch (e) {
        reject(e);
      }
    });
  }

  private async _getResources(): Promise<Array<EventResource>> {
    return new Promise<Array<EventResource>>(async (resolve, reject) => {
      try {
        const resources = await this._agendaSrv.getResources();
        resolve(resources);
      } catch (e) {
        reject(e);
      }
    });
  }

  private async _saveMeeting(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        const meeting = this._getCreationMeetingFromForm();
        if (this.meetingId) {
          await this._mpmSrv.updateMultiprofessionnalMeetings(this.meetingId, meeting);
        } else {
          await this._mpmSrv.createMultiprofessionnalMeetings(meeting);
        }
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  private async cancelBackButton(): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      try {
        if (this.hasFormChange) {
          const propositions = [
            { label: 'Ne pas sauvegarder la réunion', value: 'dont_save_meeting' },
            { label: 'Sauvegarder la réunion', value: 'save_meeting' }
          ];

          const modal = this._modalSrv.openModalMultipleChoice(
            this._viewContainerRef,
            'Attention',
            'Vous vous apprétez à changer de page, cette réunion n\'est pas sauvegardée.',
            'Que voulez-vous faire ?',
            propositions
          );
          const modalSub = modal.instance.closeEmitter.subscribe(async (choice: string | null) => {
            if (choice === 'save_meeting') {
              await this.saveMeeting();
              resolve(true);
            } else if (choice === 'dont_save_meeting') {
              resolve(true);
            }

            modalSub.unsubscribe();
          });
        } else {
          resolve(true);
        }
      } catch (e) {
        resolve(false);
      }
    });
  }

  private _doSelectPatient(patient: SelectPatient): void {
    if (this.patientsTable && this.patientsTable.objects) {
      const index = this.patientsTable.objects.findIndex(p => p.id === patient.patientId);
      const patientDisplayTable = this.patientsTable.objects.find(p => p.id === patient.patientId);

      if (patient.doSelect) {
        Object.defineProperty(patientDisplayTable, 'rowColor', { configurable: true, value: 'var(--primary)' });
        Object.defineProperty(patientDisplayTable, 'textColor', { configurable: true, value: 'var(--white)' });
      } else {
        Object.defineProperty(patientDisplayTable, 'rowColor', { configurable: true, value: 'transparent' });
        Object.defineProperty(patientDisplayTable, 'textColor', { configurable: true, value: 'var(--black)' });
      }

      this.patientsTable.objects.splice(index, 1, patientDisplayTable);
    }
  }

  private _getCreationMeetingFromForm(): CreationReunionPluriprofessionnelle {
    const dateStart = moment(this.formGroup.get('dateStart').value).toDate();
    const hourStart = this.formGroup.get('hourStart').value;
    const hourEnd = this.formGroup.get('hourEnd').value;

    const caregivers: Array<CreationReunionPluriprofessionnellePersonnelSoignant> = [];
    if (this.caregiversTable && this.caregiversTable.objects && this.caregiversTable.objects.length > 0) {
      for (const cg of this.caregiversTable.objects) {
        caregivers.push({
          id: cg.id ? cg.id : undefined,
          type: cg.meta.type,
          estPresent: cg.meta.estPresent,
          nom: cg.meta.nom
        });
      }
    }

    const patientsId: Array<string> = [];
    if (this.patientsTable && this.patientsTable.objects && this.patientsTable.objects.length > 0) {
      for (const p of this.patientsTable.objects) {
        patientsId.push(p.id);
      }
    }

    return {
      coordinateurResourceId: this.formGroup.get('coordinator').value
        ? this._resources.find(r => r.nom === this.formGroup.get('coordinator').value).id
        : undefined,
      secretaireResourceId: this.formGroup.get('secretary').value
        ? this._resources.find(r => r.nom === this.formGroup.get('secretary').value).id
        : undefined,
      adresse: this.formGroup.get('address').value ? this.formGroup.get('address').value : undefined,
      compteRendu: this.formGroup.get('report').value ? this.formGroup.get('report').value : undefined,
      dateDebut: dateStart && hourStart && hourEnd
        ? moment(dateStart).hour(Number((hourStart as string).split(':')[0])).minute(Number((hourStart as string).split(':')[1])).toDate()
        : undefined,
      dateFin: dateStart && hourStart && hourEnd
        ? moment(dateStart).hour(Number((hourEnd as string).split(':')[0])).minute(Number((hourEnd as string).split(':')[1])).toDate()
        : undefined,
      estReunionDInformation: this.formGroup.get('isConsultationMeeting').value
        ? this.formGroup.get('isConsultationMeeting').value
        : undefined,
      estReunionDeConcertation: this.formGroup.get('isCoordinationMeeting').value
        ? this.formGroup.get('isCoordinationMeeting').value
        : undefined,
      impressionEnTeteCoordinateur: this.formGroup.get('printCoordinatorHeader').value
        ? this.formGroup.get('printCoordinatorHeader').value
        : undefined,
      impressionInformation: this.formGroup.get('printInformations').value ? this.formGroup.get('printInformations').value : undefined,
      ordreDuJour: this.formGroup.get('ordreDuJour').value ? this.formGroup.get('ordreDuJour').value : undefined,
      patients: patientsId.length > 0 ? patientsId : undefined,
      personnelSoignant: caregivers.length > 0 ? caregivers : undefined,
      salleRessourceId: this.formGroup.get('room').value
        ? this._resources.find(r => r.nom === this.formGroup.get('room').value).id
        : undefined,
      titre: this.formGroup.get('title').value ? this.formGroup.get('title').value : undefined,
      rendezVousAgendaId: this.formGroup.get('eventId').value ? this.formGroup.get('eventId').value : undefined
    };
  }

  private _getMeetingFromForm(): ReunionPluriprofessionnelle {
    const dateStart = moment(this.formGroup.get('dateStart').value).toDate();
    const hourStart = this.formGroup.get('hourStart').value;
    const hourEnd = this.formGroup.get('hourEnd').value;

    const personnelSoignant: Array<ReunionPluriprofessionnellePersonnelSoignant> = [];
    if (this.caregiversTable && this.caregiversTable.objects && this.caregiversTable.objects.length > 0) {
      for (const cg of this.caregiversTable.objects) {
        personnelSoignant.push(cg.meta);
      }
    }

    const patients: Array<ReunionPluriprofessionnellePatient> = [];
    if (this.patientsTable && this.patientsTable.objects && this.patientsTable.objects.length > 0) {
      for (const p of this.patientsTable.objects) {
        patients.push(p.meta);
      }
    }

    return {
      coordinateur: this.formGroup.get('coordinator').value
        ? this._resources.find(r => r.nom === this.formGroup.get('coordinator').value)
        : undefined,
      secretaire: this.formGroup.get('secretary').value
        ? this._resources.find(r => r.nom === this.formGroup.get('secretary').value)
        : undefined,
      adresse: this.formGroup.get('address').value ? this.formGroup.get('address').value : undefined,
      compteRendu: this.formGroup.get('report').value ? this.formGroup.get('report').value : undefined,
      dateDebut: dateStart && hourStart && hourEnd
        ? moment(dateStart).hour(Number((hourStart as string).split(':')[0])).minute(Number((hourStart as string).split(':')[1])).toDate()
        : undefined,
      dateFin: dateStart && hourStart && hourEnd
        ? moment(dateStart).hour(Number((hourEnd as string).split(':')[0])).minute(Number((hourEnd as string).split(':')[1])).toDate()
        : undefined,
      estReunionDInformation: this.formGroup.get('isConsultationMeeting').value
        ? this.formGroup.get('isConsultationMeeting').value
        : undefined,
      estReunionDeConcertation: this.formGroup.get('isCoordinationMeeting').value
        ? this.formGroup.get('isCoordinationMeeting').value
        : undefined,
      impressionEnTeteCoordinateur: this.formGroup.get('printCoordinatorHeader').value
        ? this.formGroup.get('printCoordinatorHeader').value
        : undefined,
      impressionInformation: this.formGroup.get('printInformations').value ? this.formGroup.get('printInformations').value : undefined,
      ordreDuJour: this.formGroup.get('ordreDuJour').value ? this.formGroup.get('ordreDuJour').value : undefined,
      patients,
      personnelSoignant,
      salle: this.formGroup.get('room').value
        ? this._resources.find(r => r.nom === this.formGroup.get('room').value)
        : undefined,
      titre: this.formGroup.get('title').value ? this.formGroup.get('title').value : undefined,
      rendezVousId: this.formGroup.get('eventId').value ? this.formGroup.get('eventId').value : undefined,
      createur: null,
      id: this.meetingId ? this.meetingId : null,
      dateModification: this.formGroup.get('updatedAt').value,
      estTermine: this.initialMeeting ? this.initialMeeting.estTermine : false,
      estValide: this.initialMeeting ? this.initialMeeting.estValide : false
    };
  }

  private async _checkCreateAgendaEvent(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        const event = await this._generateAgendaEvent();

        if (this.initialMeeting && this.initialMeeting.id && this.initialMeeting.id !== '') {
          const ressourses: Array<EventResource> = [];
          if (event.ressoursesId && event.ressoursesId.length > 0) {
            for (const r of event.ressoursesId) {
              ressourses.push({ id: r.id, superType: r.type as SuperTypeEnum, nom: null, responsableId: null, type: null });
            }
          }
          await this._agendaSrv.updateEvent({
            createdAt: null,
            createdBy: null,
            id: this.initialMeeting.rendezVousId,
            dateDebut: event.dateDebut,
            dateFin: event.dateFin,
            description: event.description,
            ressourses,
            planifie: true
          }, false, null, true);
        } else {
          await this._agendaSrv.createEvent(event, false, true);
        }
        resolve(true);
      } catch (e) {
        if (e.status && e.status === 409 && (e.error[0].reason === 'SLOT_CONFLICT' || e.error[0].reason === 'PERIODE_CONFLICT')) {
          const modal = this._modalSrv.openModal(this._viewContainerRef, EventConflictComponent);
          modal.instance.explication = 'L\'enregistrement de ce rendez-vous rentre en conflit avec un ou plusieurs rendez-vous et/ou périodes existants dont voici la liste';
          for (const data of e.error) {
            modal.instance.conflictsList.push(data.payload);
          }
          const sub = modal.instance.closeEmitter.subscribe(async (rtd) => {
            resolve(rtd);
            modal.destroy();
            sub.unsubscribe();
          });
        } else {
          reject(e);
        }
      }
    });
  }

  private async _generateAgendaEvent(): Promise<CreationRendezVous> {
    return new Promise<CreationRendezVous>(async (resolve, reject) => {
      try {
        if (!this._defaultEventType) {
          const eventTypes = await this._agendaSrv.getEventTypes();
          for (const e of eventTypes) {
            if (e.typeParDefaut) {
              this._defaultEventType = e;
              break;
            }
          }
        }

        const meeting = this._getCreationMeetingFromForm();
        const ressoursesId: Array<RessourceCreationRendezVous> = [];
        for (const r of meeting.personnelSoignant) {
          if (r.id && r.type === TypeEnum.RessourceInterne) {
            ressoursesId.push({ id: r.id, type: 'profil' });
          }
        }

        if (meeting.salleRessourceId) {
          ressoursesId.push({ id: meeting.salleRessourceId, type: 'ressource' });
        }

        if (!ressoursesId.find(r => r.id === meeting.coordinateurResourceId)) {
          ressoursesId.push({ id: meeting.coordinateurResourceId, type: 'profil' });
        }

        if (!ressoursesId.find(r => r.id === meeting.secretaireResourceId)) {
          ressoursesId.push({ id: meeting.secretaireResourceId, type: 'profil' });
        }

        const description = `${this.formGroup.get('title').value}\n${this.formGroup.get('ordreDuJour').value}`;

        resolve({
          dateDebut: meeting.dateDebut,
          dateFin: meeting.dateFin,
          ressoursesId,
          description,
          planifie: true,
          typeId: this._defaultEventType.id
        } as CreationRendezVous);
      } catch (e) {
        reject(e);
      }
    });
  }

  private _showAlert(msg?: string): void {
    msg = msg ? msg : 'Une erreur est survenue lors de la récupération des informations de cette page';

    this._modalSrv.openAlert(this._viewContainerRef, 'Erreur', msg);
  }

}
